import type { OrderLine } from "@/graphql/codegen/graphql"

export interface PricingOrderLine extends OrderLine {
  hasFloatPallets?: boolean
}

export enum RoundOffType {
  DOWN,
  UP,
}

export enum RoundPrecisionUnit {
  Pallet,
  Bag,
}
